import TranslationService from "../../services/TranslationService.js";

let Bottombar = {
    render: async () => {
        const currentLang = localStorage.getItem('lang');
        let view =  /*html*/`
        <section class="footer">
            <div class="footerWrapper">
                <select id="login_language_switch_footer" class="login_language_switch" style="width: 80%; max-width: 260px; margin: 0 auto 24px; auto">
                ${
                    TranslationService.languages.map(lang => {
                        return `<option value="${lang.key}" ${lang.key === currentLang ? 'selected' : ''}>${lang.name}</option>`;
                    }).concat('')
                }
                </select>
                <p>By accessing, continuing to use or navigating throughout this site you accept that we will use certain browser cookies to improve your customer experience with us. Our site only uses cookies which will improve your experience with us and will not interfere with your privacy. Please refer to our Cookies Policy for further information on our use of cookies and how you can disable or manage their use should you wish.</p>
                <p>Gambling can be addictive, please play responsibly. For information on support measures, please visit our Responsible Gambling Help page.</p>
                <p>© 2020-2020. All rights reserved.</p>
            </div>
        </section>
        `
        return view
    },
    after_render: async () => {
        $('#login_language_switch_footer').on('change', (event) => {
            TranslationService.setLanguage(event.target.value);
        });
    }

}

export default Bottombar;
